import Button from '../../elements/Button'
import IconMessage from '/public/icons/icon-message.svg'
import { useModalContext } from '../../../providers/modalProvider'
import styles from './styles.module.scss'
import { withModifiers } from '../../helpers/withModifiers'

const Message = ({ title, subtitle, button, type = 'success' }) => {
  const { handleCloseModal } = useModalContext()

  return (
    <div className={withModifiers('message', [type], styles)}>
      <IconMessage />

      <h2 className={styles.message__title}>{title}</h2>

      {subtitle && <p className={styles.message__subtitle}>{subtitle}</p>}

      <Button
        onClick={() => handleCloseModal()}
        href={button.href && button.href}
        arrow={button?.arrow}
      >
        {button.label}
      </Button>
    </div>
  )
}

export default Message
